import { useOutletContext } from 'react-router-dom';
import ChatHistory from '../../components/ChatHistory/ChatHistory';
import ChatBox from '../../components/ChatBox/ChatBox';
import { DashboardContextType } from './Dashboard';
import './Dashboard.scss';
import { useEffect, useState } from 'react';
 
function DashboardWrapper() {
  const { isHistoryOpen, toggleHistory } = useOutletContext<DashboardContextType>();
  const [currentConversationId, setCurrentConversationId] = useState<string | null>(null);
  const [startNewChat, setStartNewChat] = useState<boolean>(false);
  const [chatKey, setChatKey] = useState<string>('initial-chat'); // Add a key to force re-render
  const [toggleTrySuggestion, setToggleTrySuggestion] = useState(false);
  const [suggestionBox, setSuggestionBox] = useState<boolean>(true);
  // Log state changes for debugging
  useEffect(() => {
  }, [currentConversationId, startNewChat, chatKey]);
  
  // Handle conversation selection
  const handleConversationSelect = (conversationId: string) => {
    setCurrentConversationId(conversationId);
    setSuggestionBox(false)
  };
  
  // Handle start new chat
  const handleStartNewChat = (start: boolean) => {
    setSuggestionBox(true);
    
    if (start) {
      // Generate a new unique key to force ChatBox to re-mount
      const newKey = `new-chat-${Date.now()}`;
      setChatKey(newKey);
      
      // Clear conversation ID
      setCurrentConversationId(null);
      
      // Set start new chat flag
      setStartNewChat(true);
    } else {
      setStartNewChat(false);
    }
  };
  
  return (
    <div className='chat-content-wrapper'>
      <ChatHistory 
        isHistoryOpen={isHistoryOpen} 
        onHistoryToggle={toggleHistory} 
        onConversationSelect={handleConversationSelect} 
        onStartChat={handleStartNewChat} 
        currentConversationId={currentConversationId}
        toggleTrySuggestion={toggleTrySuggestion}
        setToggleTrySuggestion={setToggleTrySuggestion}
      />
      <ChatBox 
        key={chatKey} 
        conversationId={currentConversationId} 
        startChat={startNewChat} 
        handleConversationSelect={handleConversationSelect}
        setToggleTrySuggestion={setToggleTrySuggestion}
        setSuggestionBox={setSuggestionBox}
        suggestionBox={suggestionBox}
      />
    </div>
  );
}
 
export default DashboardWrapper;